// src/utils/permission.js
export function filterRoutes(routes, permissions) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children) {
      tmp.children = filterRoutes(tmp.children, permissions)
    }
    const hasPermission = tmp.meta?.permission && permissions.includes(tmp.meta.permission)
    const hasChildren = tmp.children && tmp.children.length > 0
    if (hasPermission || hasChildren) {
      if (!hasPermission && hasChildren && tmp.meta) {
        delete tmp.meta.permission
      }
      res.push(tmp)
    }
  })
  return res
}